<template lang="pug">
  .page-container
    .app-breadcrumbs
      v-container.breadcrumbs-container
        img.breadcrumbs-logo(src="../../assets/logo.png")/
        v-breadcrumbs(:items="breadcrumbs")
          template(slot="item" slot-scope="props")
            router-link(
              :to="props.item.to"
              class="app-breadcrumbs__item"
            ) {{ props.item.text }}


    v-container
      div.about-us(v-html="data")

      Loading(v-if='isLoading')
</template>

<script>
import common from "../../api/common.js";
import Loading from "../../components/common/loading";

export default {
  data() {
    return {
      isLoading: true,
      data: ""
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          to: { name: "home" },
          disabled: false,
          text: this.$t("nav.home")
        },
        {
          to: { name: "company" },
          disabled: false,
          text: this.$t("nav.company")
        }
      ];
    }
  },
  mounted() {
    this.loadAboutUs();
  },
  components: {
    Loading
  },

  methods: {
    async loadAboutUs() {
      this.isLoading = true;
      try {
        const res = await common.aboutUs();
        this.isLoading = false;
        if (res.data.status == "fail") {
          this.$toasted.show(res.data.msg);
        } else if (res.data.status == "SUCCESSS") {
          this.data = res.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>
<style scoped lang="sass" src="./company.sass"></style>
